<template>
    <v-app>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Work Activities (Average Time)
        </div>
        <slider :sliders="activities"></slider>
    </v-app>
</template>
<script>
import db from '@/components/firebase.init';
import Slider from '@/components/Slider';
export default {
    data(){
        return{
            activities:[
                {
                    title: "Hours Sitting",
                    model_day: 12,
                    model_week: 83
                },
                {
                    title: "Hours Standing",
                    model_day: 12,
                    model_week: 83
                },
                {
                    title: "Hours Walking",
                    model_day: 12,
                    model_week: 83
                },
                {
                    title: "Hours at Computer Station",
                    model_day: 12,
                    model_week: 83
                }
            ]
        }
    },
    methods:{
        submit(id){
            var min=1; 
    var max=35;  
    var random = Math.random() * (+max - +min) + +min; 
            db.collection('forms').doc(id).update(
                {
                    activities: this.activities,
                    workingHours : random
                }
            );
        }
    },
    components:{
        'slider' : Slider
    }
}
</script>
